"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyAmountSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
exports.CurrencyAmountSchema = zod_1.z.object({
  currency_id: zod_1.z.coerce.number().transform(value => zod_1.z.nativeEnum(lingo2_models_1.CurrencyEnum).parse(value)),
  amount: zod_1.z.coerce.number()
});
